export default "__VITE_ASSET__b7bfa902__"